import { InputNumber } from "antd";
import TextField2 from "../textfields/TextField2";
import PrimaryButton from "../buttons/PrimaryButton";
import Icon1 from "../icons/Icon";
import SecondaryButton from "../buttons/SecondaryButton";

import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi";
import { useSnackbar } from "notistack";
import { Switch, useTheme } from "@mui/material";
import SmallSpinner from "../loading/SmallSpinner";
import { useNavigate } from "react-router-dom";
import Space from "../layout/Space";
import { use, useEffect, useState } from "react";

import { useAppContext } from "../config/AppContext";
import deleteDocApi from "../api/database/deleteDocApi";

import {
  getDocDataByRef,
  getFlutterTime,
  queryCollection,
} from "../models/DataFunctions";
import UploadFacturePayment from "../api/upload/UploadFacturePayment";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken";
import { format } from "date-fns";
import { getRefFromId } from "../models/DataFunctions";

import sendPennylaneDeleteQuote from "../api/pennylane/sendPennylaneDeleteQuote";
import sendPennylaneGetQuoteUrl from "../api/pennylane/sendPennylaneGetQuoteUrl";
import sendPennylaneUpdateQuoteStatus from "../api/pennylane/sendPennylaneUpdateQuoteStatus";

const PennylaneDevis = ({ userData, orgData, devisData, handleRefresh }) => {
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };
  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const [deleteOpen, setDeleteOpen] = useState(null);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [payment_open, setPaymentOpen] = useState(null);
  const theme = useTheme();
  const [quotes_pennylane, setQuotesPennylane] = useState([]);
  const [loadingQuotess, setLoadingQuotes] = useState(true);
  const [loadingDeleteMission, setLoadingDeleteMission] = useState(null);
  const [loadingOpenQuotes, setLoadingOpenQuotes] = useState(null);
  const [loadingFinalizeQuotes, setLoadingFinalizeQuotes] = useState(null);
  const [loadingUpdateQuoteStatus, setLoadingUpdateQuoteStatus] =
    useState(null);

  const [loadingReportsMission, setLoadingReportsMission] = useState(null);
  const [openRapports, setOpenRapports] = useState(null);

  const [loadingData, setLoadingData] = useState(false);
  const [slots_items, setSlotsItems] = useState([]);
  const [selected_slot, setSelectedSlot] = useState(null);

  const handleFetchData = async () => {
    let pennylane_quotes = await queryCollection("pennylane_devis", [
      {
        field: "devis_id",
        operator: "==",
        value: devisData.id,
      },
    ]);

    setQuotesPennylane(pennylane_quotes);
    setLoadingQuotes(false);
  };

  useEffect(() => {
    if (!devisData) return;
    handleFetchData();
  }, [devisData]);

  const handleOpenQuote = async (quote) => {
    setLoadingOpenQuotes(quote.id);
    const token = await getOrRefreshFirebaseToken();
    let res = await sendPennylaneGetQuoteUrl(
      quote.pennylane_devis_id,
      token,
      prefix
    );
    if (res?.url) {
      window.open(res.url, "_blank");
    } else {
      handleClickVariant("Erreur lors de l'ouverture de la facture", "error");
    }
    setLoadingOpenQuotes(null);
  };

  const handleDeletePennylaneQuote = async (quote) => {
    setLoadingDeleteMission(quote.id);
    const token = await getOrRefreshFirebaseToken();
    await sendPennylaneDeleteQuote(quote.pennylane_devis_id, token, prefix);
    let reff = getRefFromId("pennylane_facture", quote.id);
    await deleteDocApi(reff, prefix);

    handleClickVariant("Facture Pennylane supprimée", "success");
    handleRefresh();
    setLoadingUpdateQuoteStatus(null);
  };

  const handleUpdatePennylaneQuoteStatus = async (quote, status) => {
    setLoadingUpdateQuoteStatus(quote.id);
    const token = await getOrRefreshFirebaseToken();
    await sendPennylaneUpdateQuoteStatus(
      quote.pennylane_devis_id,
      status,
      token,
      prefix
    );
    let reff = getRefFromId("pennylane_devis", quote.id);
    await updateDocDataFieldApi(reff, "status", status, prefix);

    handleClickVariant("Devis Pennylane mise à jour", "success");
    handleRefresh();
    setLoadingUpdateQuoteStatus(null);
  };

  if (loadingQuotess) {
    return <SmallSpinner></SmallSpinner>;
  }

  return (
    <div className="flex flex-col h-fit gap-2 justify-end items-start mt-">
      <div className="flex flex-col gap-2 w-full">
        {quotes_pennylane
          .sort((a, b) => b.creation_time - a.creation_time)
          .map((quote, index) => (
            <div
              key={index}
              className={`flex flex-col border-l-2  space-1  p-2 ${"border-neutral-400 "}`}
            >
              <div className="text-h3 font-light">
                {
                  quote.type // Convert the Timestamp and format it
                }
                <div className="text-h3 ">
                  {
                    quote.pdf_quote_subject // Convert the Timestamp and format it
                  }
                </div>{" "}
              </div>
              {quote.status === "accepted" && (
                <div className="text-h3  text-green-500 my-2 flex flex-row border items-center gap-2 bg-green-50 px-2 py-1 w-fit rounded-lg">
                  <Icon1 icon_name="done2" size={18} fill="#22c55e" />
                  Devis validé par le client
                </div>
              )}
              {quote.status === "denied" && (
                <div className="text-h3  text-red-500 my-2 border flex flex-row items-center gap-2 bg-red-50 px-2 py-1 w-fit rounded-lg">
                  <Icon1 icon_name="cancel" size={18} fill="red" />
                  Devis refusé par le client
                </div>
              )}
              {quote.status === "wait" && (
                <div className="text-h3  text-neutral-400 my-2 border flex flex-row items-center gap-2 bg-neutral-50 px-2 py-1 w-fit rounded-lg">
                  <Icon1 icon_name="done2" size={18} fill="grey" />
                  Devis généré
                </div>
              )}
              <div className="text-h3  text-shadow_50">
                Devis créée le{" "}
                {
                  quote.creation_time &&
                    format(quote.creation_time?.toDate(), "dd/MM/yyyy HH:mm:ss") // Convert the Timestamp and format it
                }
              </div>
              <div className="text-h3 font-light text-shadow_50 mb-2">
                {quote.quote_lines && quote.quote_lines.length > 0 && (
                  <div className="flex flex-col gap-1">
                    {(
                      quote.quote_lines[0].label +
                      " - " +
                      quote.quote_lines[0].description
                    ).substring(0, 100) + "..."}
                  </div>
                )}{" "}
              </div>{" "}
              <div className="text-h3 font-light text-shadow_25 ">
                pennylane_devis_id{" "}
                {
                  quote.pennylane_devis_id // Convert the Timestamp and format it
                }
              </div>{" "}
              <div className="text-h3 font-light text-shadow_25 mb-2">
                hexagone_pennylane_devis_id{" "}
                {
                  quote.id // Convert the Timestamp and format it
                }
              </div>{" "}
              <div className="flex flex-row gap-2">
                {!quote.finalisation_date && (
                  <>
                    <SecondaryButton
                      className="h-fit w-fit "
                      disabled={loadingDeleteMission === quote.id}
                      onClick={() => handleDeletePennylaneQuote(quote)}
                    >
                      Supprimer{" "}
                      <SmallSpinner
                        loading={loadingDeleteMission === quote.id}
                      />
                    </SecondaryButton>
                    <SecondaryButton
                      className="h-fit w-fit "
                      disabled={loadingUpdateQuoteStatus === quote.id}
                      onClick={() =>
                        handleUpdatePennylaneQuoteStatus(quote, "accepted")
                      }
                    >
                      Signé{" "}
                      <SmallSpinner
                        loading={loadingUpdateQuoteStatus === quote.id}
                      />
                    </SecondaryButton>{" "}
                    <SecondaryButton
                      className="h-fit w-fit "
                      disabled={loadingUpdateQuoteStatus === quote.id}
                      onClick={() =>
                        handleUpdatePennylaneQuoteStatus(quote, "denied")
                      }
                    >
                      Refusé{" "}
                      <SmallSpinner
                        loading={loadingUpdateQuoteStatus === quote.id}
                      />
                    </SecondaryButton>{" "}
                  </>
                )}

                <SecondaryButton
                  className="h-fit w-fit "
                  disabled={loadingOpenQuotes === quote.id}
                  onClick={() => handleOpenQuote(quote)}
                >
                  Ouvrir{" "}
                  <SmallSpinner loading={loadingOpenQuotes === quote.id} />
                </SecondaryButton>
              </div>
            </div>
          ))}
      </div>{" "}
      {quotes_pennylane.length === 0 && (
        <div className="flex flex-col  w-fit rounded-xl items-center h-fit my-1 bg-neutral-50 p-2 border-l-3 border-neutral-400 ">
          <div className="text-h3 text-neutral-400 font-medium   gap-2 flex flex-row items-center">
            <Icon1 icon_name="pennylane" fill="grey" size={18} />
            Aucun devis Pennylane créé pour ce devis
          </div>
        </div>
      )}
    </div>
  );
};

export default PennylaneDevis;
